module.exports = __webpack_public_path__ + "img/header-engagementRingsVintage@2x.57f3195.jpg";